import * as UserActions from './../../../actions/user_actions';
import * as PatientsActions from './../../../actions/admin/patients_actions';
import extend from 'lodash/extend';
// import * as SettingScreen from './../actions/settingScreen';


export var Patients = (state = {

    AllPatientsData: null,
    AllStaffData: null,
    PatientInfo: null,
    RedflagPatient:null,
    TimeStamp:null
}, action) => {

    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case "@@redux/INIT": {
        }
        case 'persist/REHYDRATE': {
            if (action.payload && action.payload.Patients) {

                return extend({}, state, action.payload.Patients);
            } else {
                return state;
            }
        }
            break;
        // need to remove
        case PatientsActions.GET_ALL_PATIENTS_DATA:
            {
                return extend({}, state, { AllPatientsData: action.data });
            }
            break;
        // need to remove
        case PatientsActions.GET_ALL_STAFF_DATA:
            {
                return extend({}, state, { AllStaffData: action.data });
            }
            break;
        case PatientsActions.GET_PATIENT_INFO:
            {
                return extend({}, state, { PatientInfo: action.data });
            }
            break;
        case PatientsActions.REDFLAG:
                {
                    return extend({}, state, { RedflagPatient: action.data, TimeStamp:new Date().getTime() });
                }
                break;

        case UserActions.USER_LOG_OUT: {

            return extend({}, state, {
                AllPatientsData: null,
                AllStaffData: null,
                PatientInfo: null,RedflagPatient:null
            })
        }
            break;
        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/admin/patients/patient_reducer.js
 **/